var React = require('react');

function Camera (props) {
    return React.createElement("svg",props,[React.createElement("defs",{"key":0},React.createElement("style",null,".cls-1{fill:#0072ff;}")),React.createElement("title",{"key":1},"Record Video"),React.createElement("g",{"id":"Layer_2","data-name":"Layer 2","key":2},[React.createElement("path",{"className":"cls-1","d":"M11.92,52H36.23a7.86,7.86,0,0,0,7.86-7.86V19.89A7.86,7.86,0,0,0,36.23,12H11.92A7.92,7.92,0,0,0,4,19.95V44.05A7.92,7.92,0,0,0,11.92,52ZM36,18a2,2,0,1,1-2,2A2,2,0,0,1,36,18Z","key":0}),React.createElement("path",{"className":"cls-1","d":"M60,43.76V20.24a2.64,2.64,0,0,0-3.85-2.35l-6.32,3.24A3.27,3.27,0,0,0,48.06,24V40a3.27,3.27,0,0,0,1.77,2.9l6.32,3.25A2.64,2.64,0,0,0,60,43.76Z","key":1})])]);
}

Camera.defaultProps = {"viewBox":"0 0 64 64"};

module.exports = Camera;

Camera.default = Camera;
